var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.998 12.5243C3.198 12.5243 3.396 12.435 3.52667 12.2643L3.81667 11.8876C4.25067 14.4623 6.054 16.665 8.614 17.5536C9.402 17.827 10.2107 17.9583 11.0087 17.9583C13.398 17.9583 15.6973 16.7797 17.074 14.7043C17.2773 14.3977 17.1933 13.9837 16.8867 13.7803C16.5787 13.5757 16.1667 13.661 15.962 13.9677C14.4627 16.2303 11.6207 17.1877 9.052 16.2943C6.92067 15.5543 5.434 13.699 5.11667 11.5443L5.68733 11.9836C5.98 12.207 6.398 12.1536 6.622 11.8616C6.84667 11.5696 6.79267 11.1516 6.50067 10.927C6.50067 10.927 4.924 9.71298 4.92 9.71032C4.58867 9.45498 4.11733 9.31165 3.81734 9.70298L2.47067 11.4516C2.246 11.7436 2.3 12.1617 2.592 12.3863C2.71267 12.479 2.856 12.5243 2.998 12.5243Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04049 7.55433C5.34649 7.75767 5.76049 7.67367 5.96516 7.367C7.46449 5.105 10.3092 4.14767 12.8752 5.04033C15.0065 5.78033 16.4932 7.63567 16.8105 9.79033L16.2398 9.351C15.9472 9.127 15.5292 9.18033 15.3052 9.473C15.0805 9.765 15.1345 10.183 15.4265 10.4077C15.4265 10.4077 17.0032 11.621 17.0072 11.6243C17.3445 11.8837 17.8052 12.029 18.1098 11.6317L19.4565 9.883C19.6812 9.591 19.6272 9.173 19.3352 8.94833C19.0432 8.72367 18.6245 8.77833 18.4005 9.07033L18.1105 9.447C17.6765 6.87233 15.8732 4.66967 13.3132 3.781C10.1665 2.689 6.68916 3.86033 4.85316 6.62967C4.64982 6.937 4.73382 7.35033 5.04049 7.55433Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/RefreshIcon.b81a0691c73ebdeb4afff42f058703a2.svg";
export { ForwardRef as ReactComponent };